import { I18n as I } from 'react-redux-i18n';
export const APP_NAME = 'VDFM Bidding';

export const GENERIC_ERROR = I.t('GENERIC_ERROR');

export const LANG_COOKIE_NAME = 'lang';
export const LANG_COOKIE_EXPIRE_DAYS = 30;

export const TOKEN_STORAGE_KEY = 'ACCESS_TOKEN';

export const MENU_DROPDOWN_NAME = 'menu';
export const NOTIFICATIONS_DROPDOWN_NAME = 'notifications';
export const USER_PROFILE_DROPDOWN_NAME = 'userProfile';
export const LANGUAGES_DROPDOWN_NAME = 'languages';

export const AUCTION_WARNING_EXPIRING_HOURS = 3;
export const BID_STEP = 50;

export const ImagesUrlPrefix = '/images/cars';
export const ThumbsSuffix = '_thumb';

export const MONTHS = [
  '',
  'Ιαν',
  'Φεβ',
  'Μαρ',
  'Απρ',
  ' Μαι',
  'Ιουν',
  'Ιουλ',
  'Αυγ',
  'Σεπ',
  'Οκτ',
  'Νοβ',
  'Δεκ',
];

/* REPORTING */
export const REPORT_PALETTE = [
  { stroke: '#4caad6', fill: '#5cbae6' },
  { stroke: '#a6c947', fill: '#b6d957' },
  { stroke: '#eab354', fill: '#fac364' },
  { stroke: '#7cc3ef', fill: '#8cd3ff' },
  { stroke: '#c988bb', fill: '#d998cb' },
  { stroke: '#e2c239', fill: '#f2d249' },
  { stroke: '#83a9b6', fill: '#93b9c6' },
  { stroke: '#bcb598', fill: '#ccc5a8' },
  { stroke: '#42aabc', fill: '#52bacc' },
  { stroke: '#cbcb36', fill: '#dbdb46' },
  { stroke: '#889aeb', fill: '#98aafb' },
];
